import { Utente } from '@hm_app/@core/models/utente';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';

@Component({
    selector: 'ngx-change-auth',
    templateUrl: './change-auth.component.html',
    styleUrls: ['./change-auth.component.scss'],
})
export class ChangeAuthComponent implements OnInit {

    user: Utente;
    //force = false;

    show_annulla: true;
    show_nega: true;
    show_autorizza: true;
    show_forza: false;
    show_richiedi: false;

    title: string;
    new_status: any;
    auth_id: number;
    cf_medico: string;
    distretto: number;
    denominazione: string;
    ruolo: string;

    auth_button = 'Autorizza';
    deny_button = 'Nega';
    force_button = "Forza l'autorizzazione"
    require_button = 'Richiedi';

    auth_status = 'authorized';
    deny_status = 'denied';
    require_status = 'required';

    @Output() authChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private service: HappyMammaService, private activeModal: NgbActiveModal) {

    }

    ngOnInit() {
    }

    closeModal() {
        this.activeModal.close();
    }

    cambiaAuth(auth_status: string) {
        this.doAutorizzazione(auth_status).then(res => {
            this.activeModal.close();
        });
    }

    forceAuth(auth_status: string) {
      this.doAutorizzazione(auth_status, true).then(res => {
          this.activeModal.close();
      });
  }


    async doAutorizzazione(auth_status: string, force = false) {
        // let status = autorizza ? 'authorized' : 'denied';
        if (this.cf_medico) {
            if (auth_status == 'required') {
                const auth = await this.service.richiediAutorizzazioneMedicoGenerico(this.user.cod_fiscale, force, this.distretto, this.cf_medico);
                this.authChanged.emit(true);
                return;
            }
            const auth = await this.service.changeDoctorAuthorization(this.cf_medico, this.denominazione, this.ruolo, auth_status).toPromise();
            this.authChanged.emit(true);
        } else if (this.distretto) {
            if (auth_status == 'required' || force) {
                const auth = await this.service.richiediAutorizzazioneDistretto(this.user.cod_fiscale, this.distretto, force).toPromise();
                this.authChanged.emit(true);
                return;
            }
            const auth = await this.service.changeDistrictAuthorization(this.distretto, auth_status).toPromise();
            // console.log(auth);
            this.authChanged.emit(true);

        }

    }

}
